<template>
  <div name="hrms-search-box" class="hrms-search-box clearfix" id="hrms-search-box">
    <div class="box-body clearfix">
	    <div v-if="searchComponents.length > 0">
        <template v-for="searchComponent in searchComponents">
          <hrms-search-box-higher-order
              v-model="inputValue"
              :boxType="searchComponent.boxType"
              :rules="searchComponent.rules"
              :condition="searchComponent.condition"
              :searchBoxLabels="searchBoxLabels[nowLang]"
              :nowLang="nowLang"
              :findLovType="findLovType"
              :checkBoxType="checkBoxType"
              :genDropdowns="genDropdowns"
              @setDataRowSearchbox="setDataRowSearchboxTable(arguments[0])"
              @validateEvent="findValid(arguments[0])"
              :listFields="listFields" />
        </template>
        <div class="col-xs-12">
          <div class="form-group-button">
            <div class="btn button-in-search bg-dark-gray" @click="clearSearchParams()"><i class="fa fa-refresh"></i>{{button[nowLang].clear}}</div>
            <div class="btn button-in-search bg-color-skin" @click="callSearch(inputValue)"><i class="fa fa-search"></i>{{button[nowLang].search}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from 'src/../config/label'
import { searchComponentGenerator, searchBoxLabels, findLovType, checkBoxType, genDropdowns } from 'components/hrmsSearchBox/searchComponents.js'
import hrmsSearchBoxHigherOrder from 'components/hrmsSearchBox/higherOrder'
import moment from 'moment'
import bus from 'assets/js/bus'

export default {
  name: 'hrms-search-box',
  data () {
    return {
      dash: this.$root.$children[0].$children[0],
      dataRow: {},
      button: labels.button,
      searchBoxLabels: searchBoxLabels,
      findLovType: findLovType,
      checkBoxType: checkBoxType,
      genDropdowns: genDropdowns,
      allChildValid: false,
      searchComponents: searchComponentGenerator(this.searchBoxAlias),
      inputValue: {},
      inputSearchDefault: {}
    }
  },
  created () {
    this.inputValue = this.initialInputValue(false)
    this.inputSearchDefault = this.initialInputValue(false)
  },
  computed: {
    tinitial () {
      let tinitial = this.dash.getTinitial()
      // return tinitial[this.nowLang]
      return tinitial['en']
    }
  },
  props: {
    value: {
      type: Object
    },
    receivedStore: {
      type: Function,
      required: true
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    searchBoxAlias: {
      type: String,
      required: true
    },
    listFields: {
      type: Object
    },
    callSearchEvent: {
      type: Function
    }
  },
  watch: {
    inputValue (newVal) {
      this.$emit('input', newVal)
    },
    tinitial () {
      this.inputValue = this.initialInputValue(false)
    }
  },
  methods: {
    setDataRowSearchboxTable (dataRow) {
      this.dataRow = dataRow
      this.$emit('setDataRowSearchboxTable', this.dataRow)
    },
    initialInputValue (clearValue) {
      let inputValue = {}
      let index = 0
      for (var searchComponent of this.searchComponents) {
        index++
        if (typeof this.tinitial[index] !== 'undefined') {
          inputValue[searchComponent.boxType] = this.tinitial[index]
        } else if (typeof this.value[searchComponent.boxType] !== 'undefined') {
          if (!clearValue) {
            inputValue[searchComponent.boxType] = this.value[searchComponent.boxType]
          } else {
            inputValue[searchComponent.boxType] = this.inputSearchDefault[searchComponent.boxType]
          }
        } else {
          inputValue[searchComponent.boxType] = this.setValueFromBoxType(searchComponent)
        }
      }
      if (inputValue.hasOwnProperty('syncond')) {
        inputValue.syncond = {
          code: '',
          description: ''
        }
      }
      return inputValue
    },
    setValueFromBoxType (searchComponent) {
      if (searchComponent.boxType.indexOf('year') !== -1) {
        return moment().year()
      } else if (searchComponent.boxType.indexOf('month') !== -1) {
        return moment().month()
      } else if (searchComponent.boxType.indexOf('staapprHres3cu') !== -1) {
        return 'N'
      } else if (searchComponent.boxType.indexOf('staappr') !== -1) {
        return 'P'
      } else {
        return ''
      }
    },
    findValid (allChildValidResult) {
      this.allChildValid = (this.allChildValid && !allChildValidResult) ? allChildValidResult : this.allChildValid
    },
    callSearch (inputValue) {
      if (typeof this.callSearchEvent !== 'undefined') {
        this.callSearchEvent()
      }
      let _this = this
      setTimeout(function () {
        _this.allChildValid = true
        Promise.all([
          bus.$emit('veeValidate'),
          _this.$validator.validateAll()
        ]).then((results) => {
          _this.$nextTick(function () {
            if (_this.allChildValid && results[1]) {
              _this.$emit('setLoadingParentBool', true)
              _this.$emit('setPreLoadParentBool', false)
              _this.$emit('setStaappr', inputValue.staappr || '')
              _this.$emit('clearTableInputSearch')
              _this.receivedStore(inputValue)
            }
          })
        })
      }, 100)
    },
    clearSearchParams () {
      this.inputValue = this.initialInputValue(true)
    }
  },
  components: {
    hrmsSearchBoxHigherOrder
  }
}
</script>

<style lang="scss">
  .form-group-button {
    margin: 20px 0 10px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// component.vue?2ebb060c